import { render, staticRenderFns } from "./actionOrderLogistic.vue?vue&type=template&id=4dc82ea5&"
import script from "./actionOrderLogistic.vue?vue&type=script&lang=js&"
export * from "./actionOrderLogistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports